import React from "react";
import { Box, Card, CardContent, Stack, Typography } from "@mui/material";
import StatBox from "../../../shared-components/StatBox";
import sample from "./markedAnswer.json";
import { ReadOnlyAnswerReview } from "../../assignment/components/answer-editor/AnswerReview";
import { FeedbackEditorTextfield } from "../../assignment/components/FeedbackEditorTextfield";

const objectiveFeedback = sample.feedback.assessmentObjectiveFeedback[0];
const studentAnswer = {
  answer: sample.answerText,
  student: { identifier: sample.studentName },
  question: { markScheme: sample.markScheme },
  teacherFeedback: sample.feedback,
};

export function SampleMarkedAnswer() {
  return (
    <Box
      component="section"
      id="explore-answer"
      aria-labelledby="sample-answer-title"
      sx={{ my: 4, scrollMarginTop: 100, "&:focus": { outline: "none" } }}
    >
      <Typography id="sample-answer-title" component="h2" variant="h5">
        Explore the sample answer
      </Typography>
      <Typography sx={{ mt: 1, mb: 2 }}>
        Read-only synthetic example · Illustrative feedback, not an exam-board
        assessment.
      </Typography>
      <Card variant="outlined">
        <CardContent>
          <Typography variant="overline">
            {sample.subject} · Year {sample.yearGroup} · Question 1
          </Typography>
          <Typography component="h3" variant="h6">
            {sample.assignmentName}
          </Typography>
          <Typography sx={{ my: 2 }}>{sample.questionText}</Typography>
          <Stack spacing={2}>
            <Box component="details">
              <Box component="summary" sx={{ cursor: "pointer" }}>
                Read the source extract
              </Box>
              <Typography
                sx={{ mt: 2, whiteSpace: "pre-wrap", lineHeight: 1.8 }}
              >
                {sample.sourceText}
              </Typography>
            </Box>
            <Box component="details">
              <Box component="summary" sx={{ cursor: "pointer" }}>
                Read the illustrative mark scheme
              </Box>
              <Typography sx={{ mt: 2 }}>
                {sample.markScheme.modelAnswerGuidance}
              </Typography>
              <Typography sx={{ mt: 1 }}>
                {objectiveFeedback.assessmentObjective.identifier}:{" "}
                {objectiveFeedback.assessmentObjective.description}
              </Typography>
              <Typography sx={{ mt: 1 }}>
                Example band (5–8 marks):{" "}
                {sample.markScheme.objectives[0].levels[0].levelCriteria}
              </Typography>
              <Typography variant="body2" sx={{ mt: 1 }}>
                This is a partial illustrative rubric, not a complete official
                mark scheme.
              </Typography>
            </Box>
          </Stack>
        </CardContent>
      </Card>
      <Card variant="outlined" sx={{ my: 2 }}>
        <CardContent>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                md: "minmax(0, 1fr) minmax(0, 2fr)",
              },
              gap: 2,
            }}
          >
            <StatBox
              title="Question Score"
              stat={`${sample.feedback.mark}/${sample.availableMarks}`}
              description="Illustrative mark for Question 1"
              cardVariant="outlined"
            />
            <Box>
              <Typography component="h3" variant="h5">
                Student feedback
              </Typography>
              <Stack direction={{ xs: "column", md: "row" }} spacing={2}>
                <FeedbackEditorTextfield
                  readOnly
                  label="What went well"
                  value={sample.feedback.feedback}
                />
                <FeedbackEditorTextfield
                  readOnly
                  label="Overall areas to improve"
                  value={sample.feedback.specificAreasOfImprovement}
                />
              </Stack>
            </Box>
          </Box>
        </CardContent>
      </Card>
      <ReadOnlyAnswerReview studentAnswer={studentAnswer} />
    </Box>
  );
}
